export interface FoodWorksDate {
  created: string;
  lastModified: string;
}

export const currentDate = (): string => new Date().toISOString();
